import React, { ReactNode, useRef } from 'react'
import styles from './Dialog.module.sass'
import { Portal } from 'react-portal'
import ShadowContainer from '../popover/ShadowContainer/ShadowContainer'
import { useKeyPressEvent } from 'react-use'
import clsx from 'clsx'

interface DialogProps {
    className?: string;
    headerClassName?: string,
    actionsClassName?: string,
    contentClassName?: string,
    zIndex?: number,
    header?: ReactNode,
    upheader?: ReactNode,
    subheader?: ReactNode,
    actions?: JSX.Element | ((params: {
        onClose?: () => void,
    }) => JSX.Element),
    onClose?: () => void,
}

export const Dialog: React.FunctionComponent<DialogProps> = (props) => {
    const waitClick = useRef(false)

    useKeyPressEvent('Escape', () => {
        props.onClose?.()
    })
    return <Portal>
        <div className={styles.dialogContainer}
             onMouseDown={event => {
                 waitClick.current = event.target == event.currentTarget
             }}
             onMouseUp={event => {
                 if (event.target == event.currentTarget && waitClick.current) {
                     waitClick.current = false
                     props.onClose?.()
                 }
             }}
             style={{ zIndex: props.zIndex }}
        >
            <ShadowContainer className={styles.dialog}>
                {
                    (props.header || props.subheader || props.upheader) && <div
                        className={clsx(props.headerClassName, styles.header)}
                    >
                        <div className={styles.upheader}>{props.upheader}</div>
                        <div className={styles.title}>{props.header}</div>
                        <div className={styles.subheader}>{props.subheader}</div>
                    </div>
                }
                <div className={clsx(props.contentClassName, styles.body)}>
                    <div className={props.className}>
                        {props.children}
                    </div>
                </div>
                <div className={clsx(props.actionsClassName, styles.actions)}>
                    {
                        typeof props.actions !== 'function' ? props.actions :
                            props.actions({
                                onClose: props.onClose
                            })
                    }
                </div>
            </ShadowContainer>
        </div>
    </Portal>
}
